import {
  AxiosInstance,
  Method,
} from 'axios';
import { request } from '@/app/utils/request';

export class Request {
  private _response: string = '';

  constructor(
    private axiosInstance: AxiosInstance,
    private method: Method,
    private url: string,
    private params?: Record<string, any>,
    private body?: Record<string, any>) {
  }

  send() {
    return request(
      this.axiosInstance,
      this.url,
      this.method,
      this.params,
      this.body,
    ).then(response => {
      this._response = response;
      return this;
    });
  }

  response() {
    return this._response;
  }
}
